import styled from 'styled-components/macro';
import { WxText } from '../..';
import {
  ProductSpecsEnum,
  ProductType,
} from '../../../hooks/api/queries/useProduct';
import { __ } from '../../../i18n/l10n';
import { breakpoint } from '../../../styles/constants';

interface Props {
  product: ProductType;
}

export const productSpecsLabels: { [key in ProductSpecsEnum]: string } = {
  [ProductSpecsEnum.description]: __('Description'),
  [ProductSpecsEnum.maintenance]: __('Maintenance'),
  [ProductSpecsEnum.fitting]: __('Fitting'),
  [ProductSpecsEnum.material]: __('Materials'),
  [ProductSpecsEnum.deliveryPromess]: __('Delivery promess'),
  [ProductSpecsEnum.manufacturing]: __('Manufacturer'),
  [ProductSpecsEnum.nextProductAvailability]: __('Next availability'),
};
const specsList = [
  ProductSpecsEnum.description,
  ProductSpecsEnum.maintenance,
  ProductSpecsEnum.fitting,
  ProductSpecsEnum.material,
  ProductSpecsEnum.deliveryPromess,
  ProductSpecsEnum.manufacturing,
];

export const ProductSpecs = ({ product }: Props) => {
  const specsLength = specsList
    .map((spec) => product[spec] && spec)
    .filter((s) => s).length;

  return (
    <Wrapper specsLength={specsLength}>
      {specsList.map(
        (spec) =>
          product[spec] && (
            <li key={spec}>
              <WxText
                title={productSpecsLabels[spec]}
                text={product[spec]}
                darkMode
              />
            </li>
          ),
      )}
    </Wrapper>
  );
};

const Wrapper = styled.ul<{ specsLength: number }>`
  display: flex;
  flex-direction: column;
  gap: 2.5rem;

  margin-bottom: 3.75rem;

  @media (min-width: ${breakpoint}) {
    flex-direction: row;
    flex-wrap: wrap;
    > li {
      width: ${(props) => (props.specsLength === 1 ? '100%' : '30%')};
    }
  }
`;
